import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  /* display: flex;
  flex-wrap: wrap; */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1em;
  grid-auto-rows: 1fr;
  align-items: stretch;
  padding: 1em 1.2em;

  ${props =>
    props.disableDefaultScroll &&
    `
    overflow-y: hidden !important;
    overflow-x: hidden !important;
    max-height: 100%;
    `}
`;

export const ThisCard = styled(Card)`
  /* margin-bottom: 1.3em; */
  border-radius: 1em;
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  min-height: 11em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  /* background: ${Colors.Color1}; */
  /* border: 1px solid ${Colors.Border_Color_1}; */
  /* margin-left: 1.2em; */
  /* border-left: ${props => (props?.destaque ? `4px solid ${Colors.Color4}` : 'none')}; */

  :nth-child(3n + 1) {
    margin-left: 0em;
  }

  .card-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .card-text {
      display: flex;
      flex-direction: column;

      .titulo {
        font-size: 0.9em;
        font-weight: 800;
        /* color: ${Colors.Color7}; */
        margin-bottom: 0.6em;
        line-height: 1.3em;
        min-height: calc(1.3em * 2);
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-clamp: 2;
        box-orient: vertical;
        color: ${Colors.Color4};
      }

      .descricao {
        font-size: 0.75em;
        font-weight: 400;
        color: ${Colors.Color6};
        margin-bottom: 0.6em;
        line-height: 1.4em;
        min-height: calc(1.4em * 3); /* garante altura de exatamente 3 linhas */
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3; /* limita a 3 linhas */
        -webkit-box-orient: vertical;
        /* suporte moderno */
        line-clamp: 3;
        box-orient: vertical;
      }
    }

    .labels {
      display: flex;
      align-items: center;
      gap: 0.4em;
      margin-top: 0.2em;

      .label {
        display: flex;
        align-items: center;
        gap: 0.35em;
        font-size: 0.7em;
        padding: 0.35em 0.4em;
        border-radius: 0.4em;
        transition: background 0.2s ease;

        i.material-icons {
          font-size: 1em;
        }
      }

      .label.link.filled {
        background: ${Colors.Color8};
        color: ${Colors.Color4};
      }

      .label.link.empty {
        color: ${Colors.Color6};
        background: transparent;
      }

      .label.anexos.filled {
        color: ${Colors.Color4};
        background: ${Colors.Color8};
      }

      .label.anexos.empty {
        color: ${Colors.Color6};
        background: transparent;
      }
    }
  }

  .card-footer {
    margin-top: 0.6em;
    display: flex;
    padding-top: 0.6em;
    align-items: center;
    justify-content: space-between;
    font-size: 0.7em;
    border-top: 1px solid ${Colors.Border_Color_1};

    .data-comunicado {
      display: flex;
      align-items: center;
      gap: 0.4em;
      color: ${Colors.Color6};

      i.material-icons {
        font-size: 0.8em;
      }
    }

    .tipo-comunicado {
      color: ${Colors.Color4};
      font-weight: 600;
    }

    .tipo-comunicado.destaque {
      font-weight: 700;
    }
  }
`;
